function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import tasks from '@/js/tasks';
import { GA_EVENTS } from '@/js/constants';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import { mapState } from 'vuex';
export default {
  name: 'SyncTableFlagInca',
  components: {
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    var _this = this;
    return {
      project_id: null,
      dataset_id: null,
      table_id: null,
      show_message: false,
      message: '',
      colorAlert: 'info',
      colorFlag: 'info',
      isLoading: false,
      valid: true,
      rules_domain: [function (v) {
        return !!v || _this.traductor('my_tasks.modals.required');
      }],
      rules: [function (v) {
        return !!v || _this.traductor('my_tasks.modals.required');
      }, function (v) {
        return /^[A-Za-z0-9-_]+$/.test(v) || 'No válido';
      }],
      list_orgs: [],
      company_domain: ""
    };
  },
  created: function created() {
    this.getListOrgsDetailed();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    noteText: function noteText() {
      return this.traductor('my_tasks.add_tables_legend');
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: 'Permite actualizar la etiqueta "inca_sync" en bigquery para la sincronizacion de la tabla y sus aspectos en Dataplex.',
        disabled: true
      }];
    }
  }),
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this2 = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this2.list_orgs = response.data;
        }
      });
    },
    limpiar: function limpiar() {
      this.project_id = "";
      this.dataset_id = "";
      this.table_id = "";
      this.company_domain = "";
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      var self = this;
      var data = {
        project_id: this.project_id,
        dataset_id: this.dataset_id,
        table_id: this.table_id
      };
      self.isLoading = true;
      TablesService.syncTable(data).then(function (res) {
        var resMessage = res.message;
        var resSuccess = res.success;
        var resData = res.data;
        self.isLoading = false;
        self.message = resMessage;
        if (resSuccess) {
          self.colorAlert = resData ? 'success' : 'info';
        } else {
          self.colorAlert = 'danger';
        }
        self.show_message = true;
      });
    },
    onSubmit2: function onSubmit2(event) {
      if (this.$refs.form.validate()) {
        var self = this;
        var data = {
          project_id: this.project_id,
          dataset_id: this.dataset_id,
          table_id: this.table_id,
          domain: this.company_domain
        };
        self.isLoading = true;
        TablesService.syncTableBigquery(data).then(function (res) {
          self.isLoading = false;
          if (res.success) {
            tasks.toast.success('La tabla ha sido sincronizada correctamente en Bigquery.');
          } else {
            tasks.toast.warning('Ocurrió un error al sincronizar la tabla en Bigquery.');
          }
        }, function (err) {
          self.isLoading = false;
        });
      }
    }
  }
};